import React from "react";

const JoinEffice = () => {
  return (
    <svg
      width="44"
      height="31"
      viewBox="0 0 44 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 15.3179H27.2497M27.2497 15.3179C24.6493 12.7175 23.1913 11.2596 20.5909 8.65918C28.26 16.377 28.3305 14.2628 20.5909 21.9767L27.2497 15.3179Z"
        stroke="white"
        strokeWidth="2.83013"
      />
      <path
        d="M13.7259 20.2348C13.7259 20.2348 13.7259 23.9228 13.7259 25.6643C13.7259 27.4058 15.1601 28.7375 16.9016 28.7375C18.6431 28.7375 36.8779 28.7375 38.7218 28.7375C40.5658 28.7375 42 27.6107 42 25.6643C42 23.7179 42 6.91732 42 5.27824C42 3.63917 40.6683 2.00009 38.7218 2.00009C36.7754 2.00009 19.0529 2.00008 16.9016 2.00008C14.7503 2.00008 13.7259 3.53672 13.7259 5.27824C13.7259 7.01976 13.7259 10.5028 13.7259 10.5028"
        stroke="white"
        strokeWidth="2.83013"
      />
    </svg>
  );
};

export default JoinEffice;
